export var CHATBOT_SET_LOADED = 'CHATBOT_SET_LOADED';
export var CHATBOT_SET_UNLOADED = 'CHATBOT_SET_UNLOADED';
export var loadChatbot = function loadChatbot() {
  return {
    type: CHATBOT_SET_LOADED
  };
};
export var unloadChatbot = function unloadChatbot() {
  return {
    type: CHATBOT_SET_UNLOADED
  };
};